/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-06-07 17:33:22
 * @LastEditors: linxi
 * @LastEditTime: 2023-07-03 16:34:55
 */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import _ from 'lodash'
import { ApplicationType, sendAsync } from '../../app/applicationSlice'
import { RootState, RootThunkApi } from '../../app/store'

import * as SP from '../../services/versionManagement'

// 版本列表
export const getVersionManagementLit = createAsyncThunk<
  void,
  SP.versionManagementParams,
  RootThunkApi<void>
>('patient/getVersionManagementLit', async (params, api) => {
  return sendAsync(SP.versionManagementLit(params), api)
})

// 版本详情
export const getVersionDetailAsync = createAsyncThunk<
  void,
  any,
  RootThunkApi<void>
>('patient/getVersionDetailAsync', async (params, api) => {
  return sendAsync(SP.versionDetailAsync(params), api)
})


// 新增获取版本原有属性
export const getVersionListAsync = createAsyncThunk<any,void,  RootThunkApi<void>>(
  'patient/getVersionListAsync',
  async (params, api) => {
    return sendAsync(SP.versionListAsync(), api)
  }
)


// 分配权限
export const getJurisdiction = createAsyncThunk<void, any, RootThunkApi<void>>(
  'patient/getJurisdiction',
  async (params, api) => {
    return sendAsync(SP.jurisdictionAsync(params), api)
  }
)


// 用于在保存版本或修改版本时调用检查是否已存在，true 可以保存 ，false不可保存
export const getAddVersionCheckNameAsync = createAsyncThunk<
  void,
  SP.versionCheckNameParams,
  RootThunkApi<void>
>('patient/getAddVersiobCheckNameAsync', async (params, api) => {
  return sendAsync(SP.addVersiobCheckNameAsync(params), api)
})


// 添加或编辑版本
export const getAddVersiobSubmitAsync = createAsyncThunk<
  void,
  SP.AddVersiobSubmitParams,
  RootThunkApi<void>
>('patient/getAddVersiobSubmitAsync', async (params, api) => {
  return sendAsync(SP.addVersiobSubmitAsync(params), api)
})

// 获取菜单
export const getMenuListAsync = createAsyncThunk<void, any, RootThunkApi<void>>(
  'patient/getMenuListAsync',
  async (params, api) => {
    return sendAsync(SP.menuListAsync(params), api)
  }
)

export const getAllSelectMenusSubmit = createAsyncThunk<
  void,
  SP.allSelectMenusSubmitParams,
  RootThunkApi<void>
>('patient/getAllSelectMenusSubmit', async (params, api) => {
  return sendAsync(SP.allSelectMenusSubmit(params), api)
}) 

// 获取全部菜单
export const getAllMenuListAsync = createAsyncThunk<void, any, RootThunkApi<void>>(
  'patient/getAllMenuListAsync',
  async (params, api) => {
    return sendAsync(SP.allMenuListAsync(params), api)
  }
)

// 获取三级菜单
export const getThreeMenuListAsync = createAsyncThunk<void, any, RootThunkApi<void>>(
  'patient/getThreeMenuListAsync',
  async (params, api) => {
    return sendAsync(SP.threeMenuListAsync(params), api)
  }
)

// 获取选中的菜单
export const getSelectMenus = createAsyncThunk<void, any, RootThunkApi<void>>(
  'patient/getSelectMenus',
  async (params, api) => {
    return sendAsync(SP.selectMenus(params), api)
  }
)

export const getSelectMenusDetail = createAsyncThunk<void, any, RootThunkApi<void>>(
  'patient/getSelectMenusDetail',
  async (params, api) => {
    return sendAsync(SP.selectMenusDetail(params), api)
  }
)

// 保存菜单
export const getSelectMenusSubmit = createAsyncThunk<
  void,
  SP.selectMenusSubmitParams,
  RootThunkApi<void>
>('patient/getSelectMenus', async (params, api) => {
  return sendAsync(SP.selectMenusSubmit(params), api)
}) 


// 获取试用版本列表
export const getVersionPageAsync = createAsyncThunk<
  any,
  void,
  RootThunkApi<void>
>('home/getVersionPageAsync', async (params, api) => {
  return sendAsync(SP.versionPageAsync(), api)
})


// 试用版本列表保存
export const getVersionChangeSubmitModal = createAsyncThunk<
  void,
  SP.versionChangeModalSubmitParams,
  RootThunkApi<void>
>('home/getVersionChangeModal', async (params, api) => {
  return sendAsync(SP.versionChangeModal(params), api)
})


